import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, ArrowLeft, Loader2, CheckCircle2 } from 'lucide-react';
import BrandLogo from '../components/BrandLogo';
import { IS_MAGIC_TEAM } from '../lib/brand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore. Riprova più tardi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FAFAFA] to-[#F4F4F5] pointer-events-none" />
      <div className="w-full max-w-md relative animate-fade-in">
        <div className="text-center mb-8">
          <BrandLogo size={96} radius={16} className={`mx-auto mb-4${IS_MAGIC_TEAM ? '' : ' shadow-xl'}`} />
          <h1 className="text-2xl font-light tracking-tight text-zinc-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Password <span className="text-gold-gradient font-medium">dimenticata?</span>
          </h1>
        </div>

        <div className="bg-white border border-zinc-200 rounded-2xl p-6 shadow-xl">
          {success ? (
            <div className="text-center py-4" data-testid="forgot-success">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-50 flex items-center justify-center">
                <CheckCircle2 className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="text-lg font-medium text-zinc-900 mb-2">Controlla la tua email</h2>
              <p className="text-zinc-600 text-sm mb-4">
                Se l'indirizzo è registrato, riceverai a breve un link per impostare una nuova password.
              </p>
              <p className="text-zinc-500 text-xs mb-6">Il link sarà valido per 1 ora.</p>
              <Link to="/login">
                <Button variant="outline" className="rounded-full border-zinc-200">
                  <ArrowLeft className="w-4 h-4 mr-2" /> Torna al login
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <p className="text-zinc-600 text-sm mb-6">
                Inserisci l'email del tuo account e riceverai un link per reimpostare la password.
              </p>
              {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>
              )}
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email" className="text-zinc-700">Email</Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400" />
                    <Input
                      id="email"
                      type="email"
                      placeholder="email@esempio.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="pl-10 bg-white border-zinc-200 text-zinc-900"
                      required
                      data-testid="forgot-email-input"
                    />
                  </div>
                </div>
                <Button
                  type="submit"
                  className="w-full bg-[#D4AF37] hover:bg-[#B8941F] text-white font-semibold rounded-full py-5"
                  disabled={loading}
                  data-testid="forgot-submit-btn"
                >
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Invia link di reset'}
                </Button>
              </form>
              <div className="mt-6 text-center">
                <Link to="/login" className="text-[#D4AF37] hover:text-[#B8941F] text-sm font-medium inline-flex items-center gap-1">
                  <ArrowLeft className="w-4 h-4" /> Torna al login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
